import { CursorSkin } from "./gen/puzzle/v1/common_pb.js";
export const DEFAULT_CURSOR_COLOR = "#8C5CFF";
export const RENDERED_CURSOR_ACCENT_COLORS = {
    [CursorSkin.COMET]: "#55F2CF",
    [CursorSkin.ORBIT]: "#FFD166",
    [CursorSkin.PRISM]: "#FF6B9E",
};
export function cursorAccentColor(skin, simpleColor = DEFAULT_CURSOR_COLOR) {
    return RENDERED_CURSOR_ACCENT_COLORS[skin] ?? simpleColor;
}
export function isRenderedCursorSkin(skin) {
    return skin in RENDERED_CURSOR_ACCENT_COLORS;
}
//# sourceMappingURL=cursor-presets.js.map